import { useSiteSettings } from "@/hooks/useSiteSettings";

interface LogoWatermarkProps {
  className?: string;
  opacity?: number;
  size?: number;
  position?: "center" | "top-right" | "bottom-left";
}

const positionClasses = {
  center: "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
  "top-right": "top-8 right-[-4rem] md:right-[-2rem]",
  "bottom-left": "bottom-8 left-[-4rem] md:left-[-2rem]",
};

const LogoWatermark = ({ className = "", opacity, size, position }: LogoWatermarkProps) => {
  const { getSetting } = useSiteSettings();

  const enabled = getSetting("watermark_enabled", "true") === "true";
  if (!enabled) return null;

  const logoUrl = getSetting("logo_url", "/lovable-uploads/2236e7c0-4083-436f-a95c-06d4486b46d6.png");
  const finalSize = size ?? parseInt(getSetting("watermark_size", "24"));
  const finalOpacity = opacity ?? parseInt(getSetting("watermark_opacity", "26"));
  const finalBlur = parseInt(getSetting("watermark_blur", "2"));
  const finalPosition = (position ?? getSetting("watermark_position", "center")) as keyof typeof positionClasses;

  return (
    <div
      className={`absolute pointer-events-none select-none ${positionClasses[finalPosition] || positionClasses.center} ${className}`}
      style={{ opacity: finalOpacity / 100 }}
      aria-hidden="true"
    >
      <img
        src={logoUrl}
        alt=""
        style={{
          width: `${finalSize}rem`,
          height: `${finalSize}rem`,
          filter: `blur(${finalBlur}px)`,
          transform: `rotate(${getSetting("watermark_rotation", "0")}deg)`,
        }}
        draggable={false}
      />
    </div>
  );
};

export default LogoWatermark;
